import { TripSummary } from "./trip-summary";
import { AddOns } from "./add-ons";
import { Container, SectionsWrapper, Section } from "./styles";
import { WhatsCovered } from "./whats-covered";
import { useBreakpoint } from "hooks/use-breakpoint";
import { TripInfoSection } from "./trip-summary/trip-info";
import { useStatsigExperiment } from "hooks/experiments/use-statsig-experiments";

export function OfferBCBody() {
  const mdBreakpoint = useBreakpoint("md");
  const { getExperimentValue } = useStatsigExperiment<{
    addOnsLocation: "addonsInPopup" | "addonsBelowCta";
  }>();

  return (
    <Container>
      {!mdBreakpoint && <TripInfoSection />}
      <SectionsWrapper>
        <Section>
          <WhatsCovered />
        </Section>
        {mdBreakpoint && (
          <Section>
            <TripSummary />
            {(getExperimentValue("exp_desktop_offer_page_layout_shift")
              .addOnsLocation || "addonsBelowCta") === "addonsBelowCta" && (
              <AddOns coloredSection />
            )}
          </Section>
        )}
      </SectionsWrapper>
    </Container>
  );
}
